import React, { useState, useEffect } from 'react';
import './Calculadora.css';

function Calculadora() {
  const [datosCalificaciones, setDatosCalificaciones] = useState({});
  const [materiaSeleccionada, setMateriaSeleccionada] = useState(null);
  const [nota, setNota] = useState('');
  const [peso, setPeso] = useState('');
  const [nuevaMateria, setNuevaMateria] = useState('');
  const [creditos, setCreditos] = useState('');
  const [notaDeseada, setNotaDeseada] = useState('');  // Estado para la nota deseada

  useEffect(() => {
    const datosGuardados = localStorage.getItem('datosCalificaciones');
    if (datosGuardados) {
      setDatosCalificaciones(JSON.parse(datosGuardados));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('datosCalificaciones', JSON.stringify(datosCalificaciones));
  }, [datosCalificaciones]);

  const agregarMateria = () => {
    if (nuevaMateria && creditos) {
      setDatosCalificaciones({
        ...datosCalificaciones,
        [nuevaMateria]: {
          creditos: parseInt(creditos),
          notasPesos: []
        }
      });
      setNuevaMateria('');
      setCreditos('');
    } else {
      alert('Debes ingresar un nombre de materia y créditos válidos.');
    }
  };

  const eliminarMateria = () => {
    if (materiaSeleccionada) {
      const nuevosDatos = { ...datosCalificaciones };
      delete nuevosDatos[materiaSeleccionada];
      setDatosCalificaciones(nuevosDatos);
      setMateriaSeleccionada(null);
    }
  };

  const agregarNotaPeso = () => {
    if (materiaSeleccionada && nota && peso) {
      const nuevaNota = parseFloat(nota);
      const nuevoPeso = parseFloat(peso);

      // Restricción para nota máxima y peso máximo
      if (nuevaNota > 5) {
        alert('La nota no puede ser mayor que 5.');
        return;
      }

      if (nuevoPeso > 100 || nuevoPeso <= 0) {
        alert('El peso debe ser un valor entre 1 y 100.');
        return;
      }

      const nuevaNotaPeso = [nuevaNota, nuevoPeso];
      const nuevasNotasPesos = [...datosCalificaciones[materiaSeleccionada].notasPesos, nuevaNotaPeso];
      
      const sumaPesos = nuevasNotasPesos.reduce((acc, [, peso]) => acc + peso, 0);

      if (sumaPesos > 100) {
        alert('La suma de los pesos en la materia no puede superar el 100%.');
      } else {
        setDatosCalificaciones({
          ...datosCalificaciones,
          [materiaSeleccionada]: {
            ...datosCalificaciones[materiaSeleccionada],
            notasPesos: nuevasNotasPesos
          }
        });
        setNota('');
        setPeso('');
      }
    }
  };

  const eliminarUltimaNotaPeso = () => {
    if (materiaSeleccionada) {
      const nuevasNotasPesos = [...datosCalificaciones[materiaSeleccionada].notasPesos];
      nuevasNotasPesos.pop();
      setDatosCalificaciones({
        ...datosCalificaciones,
        [materiaSeleccionada]: {
          ...datosCalificaciones[materiaSeleccionada],
          notasPesos: nuevasNotasPesos
        }
      });
    }
  };

  const calcularPromedioPonderadoMateria = (materia) => {
    if (materia) {
      const { notasPesos } = datosCalificaciones[materia];
      const sumaPesos = notasPesos.reduce((acc, [, peso]) => acc + peso, 0);
      const sumaProductos = notasPesos.reduce((acc, [nota, peso]) => acc + nota * peso, 0);
      return sumaPesos !== 0 ? (sumaProductos / sumaPesos).toFixed(2) : 0;
    }
    return 0;
  };

  const calcularPromedioPonderadoGeneral = () => {
    const materias = Object.keys(datosCalificaciones);
    let sumaPromediosPonderados = 0;
    materias.forEach(materia => {
      const promedio = calcularPromedioPonderadoMateria(materia);
      sumaPromediosPonderados += parseFloat(promedio);
    });
    return (sumaPromediosPonderados / materias.length).toFixed(2);
  };

  const calcularNotaNecesaria = () => {
    if (materiaSeleccionada && notaDeseada) {
        const { notasPesos } = datosCalificaciones[materiaSeleccionada];
        const sumaPesos = notasPesos.reduce((acc, [, peso]) => acc + peso, 0);
        const sumaProductos = notasPesos.reduce((acc, [nota, peso]) => acc + nota * (peso / 100), 0); // Divide peso por 100 para que sea decimal

        const pesoRestante = 100 - sumaPesos;
        if (pesoRestante === 0) {
            return "Ya has completado el 100% de la materia.";
        }

        // Multiplicamos la diferencia por el 100 para distribuir bien el peso restante
        const notaRequerida = ((notaDeseada - sumaProductos) * 100) / pesoRestante;

        if (notaRequerida > 5) {
            return `No es posible alcanzar la nota deseada con el ${pesoRestante}% restante.`;
        } else if (notaRequerida < 0) {
            return `Con el ${pesoRestante}% restante, ya tienes suficiente para alcanzar la nota deseada.`;
        } else {
            return `Necesitas sacar un ${notaRequerida.toFixed(2)} en el ${pesoRestante}% restante para alcanzar una nota de ${notaDeseada}.`;
        }
    }
    return null;
};

  return (
    <div className="calculadora">
      <h1>Calculadora de Notas</h1>
      <div>
        <h2>Agregar Materia</h2>
        <input 
          type="text" 
          placeholder="Nombre de la materia" 
          value={nuevaMateria} 
          onChange={e => setNuevaMateria(e.target.value)} 
        />
        <input 
          type="number" 
          placeholder="Créditos" 
          value={creditos} 
          onChange={e => setCreditos(e.target.value)} 
        />
        <button onClick={agregarMateria}>Agregar Materia</button>
      </div>
      
      <div>
        <h2>Materias</h2>
        <ul>
          {Object.keys(datosCalificaciones).map(materia => (
            <li 
              key={materia} 
              onClick={() => setMateriaSeleccionada(materia)}
              className={materiaSeleccionada === materia ? 'selected' : ''}
            >
              {materia}
            </li>
          ))}
        </ul>
        <button onClick={eliminarMateria} disabled={!materiaSeleccionada}>Eliminar Materia</button>
      </div>

      {materiaSeleccionada && (
        <div>
          <h2>{materiaSeleccionada}</h2>
          <div>
            <h3>Agregar Nota y Peso</h3>
            <input 
              type="number" 
              placeholder="Nota" 
              value={nota} 
              onChange={e => setNota(e.target.value)} 
            />
            <input 
              type="number" 
              placeholder="Peso (%)" 
              value={peso} 
              onChange={e => setPeso(e.target.value)} 
            />
            <button onClick={agregarNotaPeso}>Agregar Nota y Peso</button>
            <button onClick={eliminarUltimaNotaPeso}>Eliminar Última Nota</button>
          </div>
          <div>
            <h3>Notas y Pesos</h3>
            <ul>
              {datosCalificaciones[materiaSeleccionada].notasPesos.map(([nota, peso], index) => (
                <li key={index}>Nota: {nota}, Peso: {peso}%</li>
              ))}
            </ul>
          </div>
          <div>
            <h3>Promedio Ponderado de {materiaSeleccionada}</h3>
            <div className="promedio">{calcularPromedioPonderadoMateria(materiaSeleccionada)}</div>
          </div>
          <div>
            <h3>Calcular Nota Necesaria</h3>
            <input 
              type="number" 
              placeholder="Nota deseada" 
              value={notaDeseada} 
              onChange={e => setNotaDeseada(e.target.value)} 
            />
            <div>{calcularNotaNecesaria()}</div>
          </div>
        </div>
      )}

      <div>
        <h2>Promedio Ponderado General</h2>
        <div className="promedio">{calcularPromedioPonderadoGeneral()}</div>
      </div>

      <footer className="footer">
        <p>Diseñada por Juan José Osorio Reyes Ing Multimedia</p>
      </footer>
    </div>
  );
}

export default Calculadora;